import React from "react";
import Amplify, { API, graphqlOperation, Auth } from "aws-amplify";
import awsconfig from "../aws-config";
import AWSAppSyncClient, { AUTH_TYPE } from "aws-appsync";
import { createResult } from "../graphQLModel/mutations";
// import { gql, useQuery } from '@apollo/client';
import gql from "graphql-tag";
// import http from "../services/httpService"
import authService from "../services/authService";
import queryString from 'query-string';



Amplify.configure(awsconfig);

export default function Test(props) {
  const handleCTestEvent = async () => {
    console.log(queryString.parseUrl("http://localhost:3000/?result=eyJiaW5hcnkiOiIwMDAwMCIsImRhdGUiOiIyMDIwLTA4LTI2VDEwOjM1OjM4LjI3NloiLCJ1c2VybmFtZSI6ImFjMjY5OTA1LWEzODgtNGJmNy05ZDA0LTEyMDZhZjNmNTRlYiJ9"));
  };

  return <button onClick={handleCTestEvent}></button>;
}
